import { useEffect, useMemo, useState } from 'react'
import { buildCategoryTree, listCategories } from '@/services/categoryService'

/**
 * The storefront category hierarchy for menus. Fetched once by the navbar
 * and shared with the desktop strip and the phone drawer so the two never
 * disagree (and the list is not requested twice per page).
 */
export function useCategoryTree() {
  const [categories, setCategories] = useState([])

  useEffect(() => {
    let mounted = true
    listCategories()
      .then((list) => mounted && setCategories(list))
      .catch(() => {})
    return () => {
      mounted = false
    }
  }, [])

  return useMemo(() => buildCategoryTree(categories), [categories])
}
